import { render, staticRenderFns } from "./GroupsView.vue?vue&type=template&id=021044c6&lang=pug&"
import script from "./GroupsView.vue?vue&type=script&lang=ts&"
export * from "./GroupsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports